import { RocheUIHorizontalCenter } from '@repo/roche-ui';
import React, { FC, useRef } from 'react';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { blokToComponent } from '../../helpers/blok-to-component';
import { RocheButton } from './roche-button';

type RocheHorizontalCenterProps = BlokToComponentProps<{
  slotted: any[];
  slot?: string;
}>;

export const RocheHorizontalCenter: FC<RocheHorizontalCenterProps> = ({ blok, slot, getComponent }) => {
  const elementRef = useRef<HTMLDivElement>(null);

  const children = blok?.slotted?.map((item, index) => {
    const component = blokToComponent({ blok: item, getComponent }, 'horizontal-center');
    if (item.component === 'roche-button') {
      // No matter what parents or other children, we hard-code the RocheButton without marginTop here.
      return (
        <RocheButton getComponent={getComponent} blok={item} hasMarginTop={false} key={`horizontal-center-${index}`} />
      );
    }
    return component;
  });

  return (
    <div ref={elementRef}>
      <RocheUIHorizontalCenter slot={slot}>{children}</RocheUIHorizontalCenter>
    </div>
  );
};
